(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function buildNav(navEl, items) {
    if (!navEl || !items.length) return;

    var ul = document.createElement('ul');
    ul.className = 't4s-article-toc-list';

    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 't4s-article-toc-item t4s-article-toc-' + item.level;

      var link = document.createElement('a');
      link.href = '#' + item.id;
      link.textContent = item.text;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById(item.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      li.appendChild(link);
      ul.appendChild(li);
    });

    navEl.appendChild(ul);
  }

  function syncTocOffset(root) {
    var header = root.querySelector('[data-article-header]');
    var tocCol = root.querySelector('.t4s-article-toc-col');
    if (!header || !tocCol) return;

    function applyOffset() {
      tocCol.style.setProperty('--toc-offset', header.offsetHeight + 'px');
    }

    applyOffset();
    window.addEventListener('resize', applyOffset);
  }

  function initArticleToc() {
    var root = document.querySelector('.t4s-article-layout-3col');
    if (!root) return;

    syncTocOffset(root);

    var article = root.querySelector('.t4s-article-content article');
    if (!article) return;

    var headings = article.querySelectorAll('h2, h3');
    var tocCol = root.querySelector('.t4s-article-toc-col');
    var mobileToc = root.querySelector('.t4s-article-toc-mobile');

    if (!headings.length) {
      if (tocCol) tocCol.classList.add('t4s-dn');
      if (mobileToc) mobileToc.classList.add('t4s-dn');
      return;
    }

    var usedIds = {};
    var items = [];

    headings.forEach(function (heading) {
      var text = heading.textContent.trim();
      if (!text) return;

      var level = heading.tagName.toLowerCase();
      var id = heading.id || slugify(text);

      while (usedIds[id]) {
        id = id + '-2';
      }
      usedIds[id] = true;

      if (!heading.id) {
        heading.id = id;
      }

      items.push({ id: id, text: text, level: level });
    });

    buildNav(root.querySelector('[data-toc-desktop]'), items);
    buildNav(root.querySelector('[data-toc-mobile]'), items);

    var links = root.querySelectorAll('.t4s-article-toc-list a');
    if (!links.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var activeId = entry.target.id;
          links.forEach(function (link) {
            var li = link.parentElement;
            if (!li) return;
            li.classList.toggle('is-active', link.getAttribute('href') === '#' + activeId);
          });
        });
      },
      { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  } else {
    initArticleToc();
  }
})();
